module.exports = __webpack_public_path__ + "static/media/home-carousel8.e51714be.webp";